import React, { useState, useEffect, useRef } from 'react';
import styles from './MultivariateAnalysis.module.css';
import ScatterChart from './Charts/ScatterChart';
import Heatmap from './Charts/Heatmap';
import LineChart from './Charts/LineChart';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import { useMultivarientVehicleData } from './context';
import ChartLoader from '../../../Shared/Loader';

const xAxisValues = [
  { name: "Select X Parameter", value: "" },
  { name: "timeSpentInBcs_working_status_0", value: "timespentinbcs_working_status_0" },
  { name: "timeSpentInBcs_working_status_1", value: "timespentinbcs_working_status_1" },
  { name: "timeSpentInBcs_working_status_3", value: "timeSpentInBcs_working_status_3" },
  { name: "timeSpentInBcs_working_status_4", value: "timespentinbcs_working_status_4" },
  { name: "timeSpentInBcs_working_status_6", value: "timespentinbcs_working_status_6" },
  { name: "timeSpentInBcs_working_status_7", value: "timespentinbcs_working_status_7" },
  { name: "timeSpentInBcs_working_status_15", value: "timeSpentInBcs_working_status_15" },
  { name: "averageOfBMS_Max_Cell_Voltage+", value: "averageofbms_max_cell_voltage" },
  { name: "averageOfBMS_Min_Cell_Voltage", value: "averageofbms_min_cell_voltage" },
  { name: "averageOfBMS_Pack_Current", value: "averageofbms_pack_current" },
  { name: "averageOfMCU_Current_DC", value: "averageofmcu_current_dc" },
  { name: "maxOfMCU_Current_DC", value: "maxofmcu_current_dc" },
  { name: "maxOfMCU_Motor_Torque", value: "maxofmcu_motor_torque" },
  { name: "medianOfMCU_Motor_Torque", value: "medianofmcu_motor_torque" },
  { name: "timeSpentInMcu_regenstatus_1", value: "timespentinmcu_regenstatus_1" },
  { name: "averageOfMCU_Voltage_DC", value: "averageofmcu_voltage_dc" },
  { name: "averageOfBMS_Max_Cell_Temperature", value: "averageofbms_max_cell_temperature" },
  { name: "timeSpentInMcu_brake_position_0_10", value: "timespentinmcu_brake_position_0_10" },
  { name: "timeSpentInMcu_brake_position_10_40", value: "timespentinmcu_brake_position_10_4" },
  { name: "timeSpentInMcu_brake_position_40_60", value: "timespentinmcu_brake_position_40_60" },
  { name: "timeSpentInMcu_brake_position_60+", value: "timespentinmcu_brake_position_60_plus" },
  { name: "percentageTimeSpentInMcu_throttle_position_0_1", value: "percentagetimespentinmcu_throttle_position_0_1" },
  { name: "percentageTimeSpentInMcu_throttle_position_10_30+", value: "percentagetimespentinmcu_throttle_position_10_30" },
  { name: "percentageTimeSpentInMcu_throttle_position_30_50", value: "percentagetimespentinmcu_throttle_position_30_50" },
  { name: "percentageTimeSpentInMcu_throttle_position_50_70", value: "percentagetimespentinmcu_throttle_position_50_70" },
  { name: "percentageTimeSpentInMcu_throttle_position_70+", value: "percentagetimespentinmcu_throttle_position_70_plus" },
  { name: "percentageTimeSpentInMcu_motor_rpm_0_3000", value: "percentagetimespentinmcu_motor_rpm_0_3000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_8000+", value: "percentagetimespentinmcu_motor_rpm_8000_plus" },
  { name: "percentageTimeSpentInMcu_motor_rpm_3000_5000", value: "percentagetimespentinmcu_motor_rpm_3000_5000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_5000_8000", value: "percentagetimespentinmcu_motor_rpm_5000_8000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_neg_1000_0", value: "percentagetimespentinmcu_motor_rpm_neg_1000_0" },
  { name: "maxOfBMS_Max_Cell_Temperature", value: "maxofbms_max_cell_temperature" }

];

const yAxisValues = [
  { name: "Select Y Parameter", value: "" },
  { name: "timeSpentInBcs_working_status_0", value: "timespentinbcs_working_status_0" },
  { name: "timeSpentInBcs_working_status_1", value: "timespentinbcs_working_status_1" },
  { name: "timeSpentInBcs_working_status_3", value: "timeSpentInBcs_working_status_3" },
  { name: "timeSpentInBcs_working_status_4", value: "timespentinbcs_working_status_4" },
  { name: "timeSpentInBcs_working_status_6", value: "timespentinbcs_working_status_6" },
  { name: "timeSpentInBcs_working_status_7", value: "timespentinbcs_working_status_7" },
  { name: "timeSpentInBcs_working_status_15", value: "timeSpentInBcs_working_status_15" },
  { name: "averageOfBMS_Max_Cell_Voltage+", value: "averageofbms_max_cell_voltage" },
  { name: "averageOfBMS_Min_Cell_Voltage", value: "averageofbms_min_cell_voltage" },
  { name: "averageOfBMS_Pack_Current", value: "averageofbms_pack_current" },
  { name: "averageOfMCU_Current_DC", value: "averageofmcu_current_dc" },
  { name: "maxOfMCU_Current_DC", value: "maxofmcu_current_dc" },
  { name: "maxOfMCU_Motor_Torque", value: "maxofmcu_motor_torque" },
  { name: "medianOfMCU_Motor_Torque", value: "medianofmcu_motor_torque" },
  { name: "timeSpentInMcu_regenstatus_1", value: "timespentinmcu_regenstatus_1" },
  { name: "averageOfMCU_Voltage_DC", value: "averageofmcu_voltage_dc" },
  { name: "averageOfBMS_Max_Cell_Temperature", value: "averageofbms_max_cell_temperature" },
  { name: "timeSpentInMcu_brake_position_0_10", value: "timespentinmcu_brake_position_0_10" },
  { name: "timeSpentInMcu_brake_position_10_40", value: "timespentinmcu_brake_position_10_4" },
  { name: "timeSpentInMcu_brake_position_40_60", value: "timespentinmcu_brake_position_40_60" },
  { name: "timeSpentInMcu_brake_position_60+", value: "timespentinmcu_brake_position_60_plus" },
  { name: "percentageTimeSpentInMcu_throttle_position_0_1", value: "percentagetimespentinmcu_throttle_position_0_1" },
  { name: "percentageTimeSpentInMcu_throttle_position_10_30+", value: "percentagetimespentinmcu_throttle_position_10_30" },
  { name: "percentageTimeSpentInMcu_throttle_position_30_50", value: "percentagetimespentinmcu_throttle_position_30_50" },
  { name: "percentageTimeSpentInMcu_throttle_position_50_70", value: "percentagetimespentinmcu_throttle_position_50_70" },
  { name: "percentageTimeSpentInMcu_throttle_position_70+", value: "percentagetimespentinmcu_throttle_position_70_plus" },
  { name: "percentageTimeSpentInMcu_motor_rpm_0_3000", value: "percentagetimespentinmcu_motor_rpm_0_3000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_8000+", value: "percentagetimespentinmcu_motor_rpm_8000_plus" },
  { name: "percentageTimeSpentInMcu_motor_rpm_3000_5000", value: "percentagetimespentinmcu_motor_rpm_3000_5000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_5000_8000", value: "percentagetimespentinmcu_motor_rpm_5000_8000" },
  { name: "percentageTimeSpentInMcu_motor_rpm_neg_1000_0", value: "percentagetimespentinmcu_motor_rpm_neg_1000_0" },
  { name: "maxOfBMS_Max_Cell_Temperature", value: "maxofbms_max_cell_temperature" }
];

const MultivariateAnalysisChart = () => {
  const [chartType, setChartType] = useState('Heatmap');
  const [xParam, setXParam] = useState({ name: "Select X Parameter", value: "" });
  const [yParam, setYParam] = useState({ name: "Select Y Parameter", value: "" });
  const [data, setData] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const { GlobalData } = useMultivarientVehicleData();

  const chartRef = useRef(null);

  // API call
  useEffect(() => {
    if (xParam.value !== "" && yParam.value !== "") {
      const url = API_URL_MAIN + "ace_multivarient/" + xParam.value + "_vs_" + yParam.value;

      fetchData(
        {
          url,
          body: {
            filterdata: { ...GlobalData }
          }
        },
        (res) => {
          if (!res.length) {
            setData([]);
            return;
          }
          const formatData = res.map(item => ({
            ...item,
            value: item.value > 0 ? Number(item?.value?.toFixed(2)) : 0
          }));
          setData(formatData);
        }
      );
    }
  }, [yParam.value, xParam.value, GlobalData, fetchData]);


  useEffect(() => {
    if (
      xParam.value !== "" &&
      yParam.value !== "" &&
      !isLoading &&
      data.length > 0 &&
      chartRef.current
    ) {
      setTimeout(() => {
        const element = chartRef.current;
        const rect = element.getBoundingClientRect();
        const offset = 80;

        window.scrollTo({
          top: window.scrollY + rect.top - offset,
          behavior: "smooth",
        });
      }, 150);
    }
  }, [xParam.value, yParam.value, isLoading, data.length, chartType]);

  return (
    <>
      {/* Controls */}
      <div ref={chartRef} id="apply-section" className={styles['controls-wrapper']}>
        <div className={styles['control-item']}>
          <label className='fw-bold'>Chart Type</label>
          <select
            className={`form-select ml-1 mb-2  ${styles.filter_dropdown}`}
            value={chartType}
            onChange={e => setChartType(e.target.value)}
          >
            <option value={"Heatmap"}>Heatmap</option>
            <option value={"BubbleChart"}>Bubble Chart</option>
          </select>
        </div>

        <div className={styles['control-item-axis']}>
          <label className='fw-bold'>X-Axis</label>
          <select
            className={`form-select  ${styles.filter_dropdown}`}
            value={xParam?.value || ""}
            onChange={e => {
              const selectedObj = xAxisValues.find(i => i.value === e.target.value);
              setXParam(selectedObj || { name: "Select X Parameter", value: "" });
            }}
          >
            {xAxisValues
              .filter(x => !yParam?.value || x.value !== yParam?.value)
              .map((item, idx) => (
                <option key={idx} value={item.value}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>

        <div className={`${styles['control-item-axis']}`}>
          <label className='fw-bold'>Y-Axis</label>
          <select
            className={`form-select ${styles.filter_dropdown}`}
            value={yParam?.value || ""}
            onChange={e => {
              const selectedObj = yAxisValues.find(i => i.value === e.target.value);
              setYParam(selectedObj || { name: "Select Y Parameter", value: "" });
            }}
          >
            {yAxisValues
              .filter(y => !xParam?.value || y.value !== xParam?.value)
              .map((item, idx) => (
                <option key={idx} value={item.value}>
                  {item.name}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* Chart + messages */}
      <div style={{ minHeight: "400px" }}>
        {
          (xParam.value === "" || yParam.value === "") ? (
            <div className={`d-flex justify-content-center align-items-center height-400 ${styles["height-300"]}`} >
              Please Select Two Parameters
            </div>
          ) : isLoading ? (
            <div className='d-flex justify-content-center'>
              <ChartLoader position='' height={400} />
            </div>
          ) : !data.length ? (
            <div className={`d-flex justify-content-center align-items-center height-400 ${styles["height-300"]}`} >
              Data Is Not Available For Selected Parameters
            </div>
          ) : (
            <>
              {chartType === 'Heatmap' && (
                <Heatmap
                  data={data}
                  xAxisName={xParam.name}
                  yAxisName={yParam.name}
                />
              )}

              {chartType === 'BubbleChart' && (
                <ScatterChart
                  xAxisName={xParam.name}
                  yAxisName={yParam.name}
                  data={data}
                />
              )}
            </>
          )
        }
      </div>
    </>
  );
};

export default MultivariateAnalysisChart;
